export const prospectingRoutes = {
  default:'location-prospect',
  anyProspect:'prospect_any'
}
